import { render, staticRenderFns } from "./ToggleButtonLink.vue?vue&type=template&id=1be6877a"
import script from "./ToggleButtonLink.vue?vue&type=script&lang=js"
export * from "./ToggleButtonLink.vue?vue&type=script&lang=js"
import style0 from "./ToggleButtonLink.vue?vue&type=style&index=0&id=1be6877a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports